import {
  type ID,
  ProjectActions,
  selectBlockParent,
  selectBlocksByNode,
} from '@octopus-do/octopus-project-core'
import type { BlockActions } from '@store/blockSaga/actions'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { put, select } from 'redux-saga/effects'

export function* blockOrderChange({
  payload: { id, direction },
}: ReturnType<typeof BlockActions.changeBlockOrder>) {
  const nodeIds: ID[] = yield select(selectBlockParent(id))
  const nodeId = nodeIds[0]
  const blocksByNodeId: ID[] = yield select(selectBlocksByNode(nodeId))

  const currentIndex = blocksByNodeId.indexOf(id)

  const index = direction === 'up' ? currentIndex - 1 : currentIndex + 2

  yield put(
    commitProjectRequest(
      ProjectActions.blocks.move({
        ids: [id],
        index,
        nextParentId: nodeId,
      })
    )
  )
}
